import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPractitioner = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_practitioner',
    '/api/resource/Healthcare Practitioner',
    body
  );
  return data;
});
export const updatePractitioner = catchAsync(async (id, body) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_practitioner',
    `/api/resource/Healthcare Practitioner/${id}`,
    body
  );
  return data;
});
export const getPractitioners = catchAsync(async ({ key = '', value = '' }) => {
  let baseUrl = `/api/resource/Healthcare Practitioner?fields=["name","practitioner_name", "gender", "department", "status", "mobile_phone"]&limit_start=0&limit_page_length=0&order_by=name desc`;
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
    // '/api/method/technoerp.services.get_practitioners'
    // `/api/resource/Healthcare Practitioner?fields=["name", "practitioner_name", "gender", "department", "status", "mobile_phone"]&limit_start=0&limit_page_length=0&order_by=name desc`
  );
  return data;
});
export const getPractitionerItems = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_practitioner_items'
  );
  return data;
});
export const getPractitionerSchedules = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_practitioner_schedules'
  );
  return data;
});
export const get_Specialty = catchAsync(async (lang) => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_Specialty?lang=' + lang
  );
  return data;
});
export const get_contract_type = catchAsync(async (lang) => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_contract_type?lang=' + lang
  );
  return data;
});
export const get_account_details = catchAsync(async (lang) => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_income_accounts'
  );
  return data;
});
export const getDepartments = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_departments'
  );
  return data;
});
export const getPractitionerschedulesList = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Practitioner Schedule'
  );
  return data;
});
export const getPractitionersDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_practitioner?practitioner=${id}`
    `/api/resource/Healthcare Practitioner/${id}`
  );
  return data;
});
export const deletePractitioner = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.delete_record?record=${id}&document=Healthcare Practitioner`
    `/api/resource/Healthcare Practitioner/${id}`
  );
  return data;
});
